import { gql } from "@apollo/client";

export const GetStckItemLdgrAssociDetails = gql`
  query GetStckItemLdgrAssociDetails(
    $token: String!
    $input: itemLdgrAssociData!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $orderBy: AtsStckItemLdgrAssoicOrder
    $name: String
  ) {
    GetStckItemLdgrAssociDetails(
      token: $token
      input: $input
      after: $after
      first: $first
      customer_id: $customer_id
      orderBy: $orderBy
      where: { or: [{ hasItemWith: { or: [{ descContainsFold: $name }] } }] }
    ) {
      edges {
        node {
          id
          ldgrStatus
          ldgrRemarks
          customerID
          itemID
          ldgrID
          item {
            id
            desc
            code
            groupDetails {
              groupName
            }
            categoryDetails {
              categoryName
            }
            uomDetails {
              uom
            }
            ldgr_count
          }
          ldgr {
            id
            desc
            supplier_details {
              id
              city
              state
              gstNo
              proficiency
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
